/**
 * Web kancaları ve API anahtarı ekranlarının metinleri (M5 WP 5.5). Teamgram'da bu ekranlar plan kapılıydı; düzen ve davranış
 * ÜK/PM kararıdır (docs/planning/m5-d5-notlar.md). Sır/anahtar değeri yalnız oluşturma/yenileme anında bir kez gösterilir.
 */
export const integrationsText = {
  nav: {
    webhooks: 'Web kancaları',
    myApiKeys: 'API anahtarlarım',
  },
  webhooks: {
    title: 'Web kancaları',
    description:
      'Kayıt olaylarını kendi sisteminize imzalı HTTP istekleriyle iletin. Her istek olay kimliği, sürüm, zaman damgası ve HMAC-SHA256 imzası taşır; başarısız teslimler sınırlı sayıda yeniden denenir.',
    readOnly: 'Web kancalarını yalnız çalışma alanı yöneticileri yönetebilir.',
    subscriptions: 'Abonelikler',
    newSubscription: 'Yeni abonelik',
    empty: 'Henüz abonelik yok.',
    colName: 'Ad',
    colUrl: 'Adres',
    colEvents: 'Olaylar',
    colState: 'Durum',
    colStats: 'Son 7 gün',
    active: 'Etkin',
    inactive: 'Pasif',
    allRecordTypes: 'tüm kayıt tipleri',
    stats: (d: number, f: number, u: number) =>
      `${String(d)} kabul · ${String(f)} başarısız · ${String(u)} belirsiz`,
    edit: 'Düzenle',
    sendTest: 'Deneme gönder',
    testQueued:
      'Deneme olayı kuyruğa alındı. Sonuç birkaç saniye içinde aşağıdaki teslim geçmişinde görünür.',
    problemBadge: (n: number) => `Son 7 günde ${String(n)} sorunlu teslim`,
    showProblems: 'Sorunlu teslimleri göster',
    pingEvent: 'Deneme olayı',
    retryAt: (when: string) => `Yeniden denenecek: ${when}`,
    autoRefresh: 'Bekleyen teslimler birkaç saniyede bir kendiliğinden yenilenir.',
    subsLoadFailed: 'Abonelikler yüklenemedi.',
    deliveriesLoadFailed: 'Teslim geçmişi yüklenemedi.',
    retry: 'Yeniden dene',
    rotate: 'Sırrı yenile',
    rotateTitle: 'İmza sırrı yenilensin mi?',
    rotateBody:
      'Yeni bir sır üretilir ve bir kez gösterilir. Seçtiğiniz geçiş süresi boyunca her teslim hem YENİ hem ÖNCEKİ sırla imzalanır (başlıkta iki imza); alıcı sisteminiz bildiği sırla doğrulamaya devam eder. Süre dolunca önceki sır kalıcı olarak silinir ve teslimler yalnız yeni sırla imzalanır.',
    rotatePurpose:
      'Geçiş süresi, alıcı sisteminizin sırrı kesintisiz güncelleyebilmesi içindir. Sırrın sızdığından şüpheleniyorsanız "Geçiş yok" seçin: önceki sır hemen geçersiz olur.',
    overlap: 'Geçiş süresi',
    overlapChoice: (hours: number) =>
      hours === 0
        ? 'Geçiş yok (önceki sır hemen geçersiz)'
        : hours === 24
          ? '24 saat (varsayılan)'
          : hours % 24 === 0
            ? `${String(hours / 24)} gün`
            : `${String(hours)} saat`,
    overlapNone:
      'Geçiş yok: önceki sır hemen geçersiz olur. Alıcı sisteminiz yeni sırrı kullanmaya başlayana kadar imza doğrulaması başarısız olur.',
    overlapBadge: 'Anahtar geçişi sürüyor',
    overlapStatus: (version: number, until: string) =>
      `Geçiş sürüyor — önceki anahtar (sürüm ${String(version)}) ${until} tarihine kadar da imzalıyor.`,
    overlapBlocked:
      'Geçiş sürerken yeni rotasyon yapılamaz (aynı anda en çok iki anahtar imzalar). Önce önceki anahtarı sonlandırın ya da geçişin bitmesini bekleyin.',
    expirePrevious: 'Önceki anahtarı şimdi sonlandır',
    expirePreviousTitle: 'Önceki anahtar şimdi sonlandırılsın mı?',
    expirePreviousBody:
      'Önceki sır kalıcı olarak silinir ve geri getirilemez. Bundan sonraki teslimler yalnız güncel sırla imzalanır; hâlâ önceki sırla doğrulayan alıcılar teslimleri reddeder.',
    expiredPrevious: 'Önceki anahtar sonlandırıldı; teslimler yalnız güncel sırla imzalanıyor.',
    rotatedWithOverlap: (until: string) =>
      `Sır yenilendi. Önceki anahtar ${until} tarihine kadar da imzalamaya devam eder.`,
    rotatedNoOverlap:
      'Sır yenilendi. Önceki sır geçersiz; teslimler yalnız yeni sırla imzalanıyor.',
    signedWith: (versions: readonly number[]) =>
      versions.length > 1
        ? `İmza: sürüm ${versions.map(String).join(' + ')} (çift imza — geçiş)`
        : `İmza: sürüm ${String(versions[0] ?? '')}`,
    editorTitle: (editing: boolean) => (editing ? 'Aboneliği düzenle' : 'Yeni abonelik'),
    name: 'Ad (yalnız sizin göreceğiniz ad)',
    url: 'Hedef adres (https)',
    urlHint:
      'İnternete açık bir https adresi girin. İç ağ, yerel ağ ve bulut metadata adresleri reddedilir; yönlendirmeler izlenmez.',
    events: 'Olay türleri',
    recordTypes: 'Kayıt tipleri',
    recordTypesHint: 'Hiçbiri seçilmezse tüm kayıt tipleri için gönderilir.',
    isActive: 'Abonelik etkin',
    ownerNote:
      'Olaylar, aboneliği son kaydeden yöneticinin görebildiği kayıtlarla sınırlıdır. Olay yükü yalnız kayıt kimliği, tipi ve numarasını taşır; ayrıntıyı API anahtarıyla okuyun.',
    save: 'Kaydet',
    cancel: 'Vazgeç',
    saved: 'Abonelik kaydedildi',
    failed: 'İşlem tamamlanamadı',
    atLeastOneEvent: 'En az bir olay türü seçin',
    secretTitle: 'İmza sırrı',
    secretOnce:
      'Bu sır YALNIZ şimdi gösteriliyor. Kopyalayıp alıcı sisteminizde saklayın; kapattıktan sonra bir daha görüntülenemez (gerekirse yenileyebilirsiniz).',
    secretLabel: 'Sır',
    copy: 'Kopyala',
    copied: 'Panoya kopyalandı',
    copyFailed: 'Kopyalanamadı; metni elle seçip kopyalayın',
    close: 'Kapat',
    deliveries: 'Teslim geçmişi',
    filterAll: 'Tümü',
    filterProblems: 'Başarısız ve belirsiz',
    filterLabel: 'Teslimleri süz',
    deliveriesEmpty: 'Bu görünümde teslim yok.',
    colTime: 'Zaman',
    colTarget: 'Hedef',
    colEvent: 'Olay',
    colStatus: 'Durum',
    colAttempts: 'Deneme',
    colResult: 'Son sonuç',
    automationTarget: 'Otomasyon kancası',
    more: 'Daha fazla göster',
    refresh: 'Yenile',
    details: 'Ayrıntı',
    detailTitle: 'Teslim ayrıntısı',
    eventId: 'Olay kimliği',
    deliveryId: 'Teslim kimliği',
    attempts: 'Denemeler',
    attemptRow: (n: number) => `${String(n)}. deneme`,
    noAttempts: 'Henüz deneme yapılmadı.',
    body: 'Gönderilen gövde',
    nextAttempt: 'Sonraki deneme',
    redeliveryOf: 'Yeniden teslimi yapılan teslim',
    redeliver: 'Yeniden teslim et',
    redeliverTitle: 'Olay yeniden teslim edilsin mi?',
    redeliverBody:
      'Aynı olay kimliğiyle yeni bir teslim oluşturulur. Alıcı sisteminiz olay kimliğine (Castinflow-Event-Id / Idempotency-Key) göre tekrarları ayıklayabilir.',
    redeliverUnknown:
      'Dikkat: bu teslimin sonucu belirsiz — istek alıcıya ulaşmış olabilir. Alıcı tarafta olayın işlenip işlenmediğini kontrol edin; yeniden teslim aynı olay kimliğini taşır.',
    redelivered: 'Yeniden teslim kuyruğa alındı',
    tenantSecret: 'Otomasyon kancası imza sırrı',
    tenantSecretHint:
      'Otomasyonların "Kanca gönder" adımı bir adrese doğrudan gönderir ve bu çalışma alanı sırrıyla imzalar. Sır tanımlı değilse otomasyon kancaları gönderilmez.',
    tenantSecretMissing: 'Sır tanımlı değil — otomasyon kancaları gönderilmez.',
    tenantSecretVersion: (v: number) => `Sürüm ${String(v)}`,
    tenantSecretCreate: 'Sır oluştur',
    tenantSecretRotate: 'Sırrı yenile',
    testReceivers:
      'Bu sunucu üretim dışı kipte çalışıyor: yalnız sistem yöneticisinin tanımladığı sabit test alıcılarına iç adresten gönderilebilir.',
    verifyTitle: 'İmzayı doğrulama',
    verifyBody:
      'Her istekte Castinflow-Signature başlığı "t=<unix saniye>,v1=<onaltılık>" biçimindedir. İmza, sırrın UTF-8 baytlarıyla "<t>.<gövde>" metninin HMAC-SHA256 değeridir. Zaman damgası 5 dakikadan eskiyse isteği reddedin; aynı Castinflow-Event-Id ile gelen tekrarları bir kez işleyin. 2xx dışındaki yanıtlar başarısız sayılır; 5xx, 408 ve 429 sınırlı sayıda (en çok 5 deneme) yeniden denenir. Yanıt gelmeyen teslimler "sonucu belirsiz" olarak işaretlenir ve kendiliğinden tekrarlanmaz.',
    verifyRotation:
      'Sır yenileme geçişi sürerken başlıkta iki imza bulunur: "t=<unix>,v1=<yeni sırla>,v1=<önceki sırla>". Doğrulayıcınız başlıktaki TÜM v1 değerlerini denemeli ve herhangi biri eşleşirse isteği kabul etmelidir; böylece sırrı geçiş süresi içinde kesintisiz güncelleyebilirsiniz.',
  },
  apiTokens: {
    tab: 'API anahtarı',
    general: 'Genel',
    title: 'API anahtarları',
    description:
      'API anahtarı, kayıt API uçlarına (okuma, sorgu, oluşturma, güncelleme) bu kullanıcının yetkisiyle erişir; seçtiğiniz kapsamın ve kullanıcının görebildiği kayıtların dışına çıkamaz. İstekte "X-Api-Token" başlığıyla gönderilir.',
    empty: 'Henüz API anahtarı yok.',
    create: 'Yeni anahtar',
    othersNote:
      'Başka bir kullanıcı adına anahtar oluşturulamaz. Yönetici olarak bu kullanıcının anahtarlarını görebilir ve iptal edebilirsiniz.',
    colName: 'Ad',
    colHint: 'Son 4 karakter',
    colScopes: 'Kapsam',
    colExpires: 'Son kullanma',
    colLastUsed: 'Son kullanım',
    colState: 'Durum',
    never: 'Hiç kullanılmadı',
    state: { active: 'Etkin', expired: 'Süresi doldu', revoked: 'İptal edildi' } as const,
    revoke: 'İptal et',
    revokeTitle: 'API anahtarı iptal edilsin mi?',
    revokeBody:
      'Anahtar hemen geçersiz olur; bu anahtarı kullanan entegrasyonlar çalışmayı durdurur. İptal geri alınamaz.',
    revoked: 'API anahtarı iptal edildi',
    formTitle: 'Yeni API anahtarı',
    name: 'Ad (ör. entegrasyonun adı)',
    expires: 'Geçerlilik süresi',
    days: (d: number) => `${String(d)} gün`,
    rate: 'Dakikalık istek sınırı',
    scopes: 'Kapsam',
    scopesHint: 'Yazma, okumayı içerir. Yetkinizin olmadığı erişim seçilemez.',
    access: { none: 'Erişim yok', read: 'Okuma', write: 'Okuma + yazma' } as const,
    atLeastOneScope: 'En az bir kaynak için erişim seçin',
    save: 'Oluştur',
    cancel: 'Vazgeç',
    secretTitle: 'API anahtarı oluşturuldu',
    secretOnce:
      'Bu anahtar YALNIZ şimdi gösteriliyor. Kopyalayıp güvenli bir yerde saklayın; kapattıktan sonra bir daha görüntülenemez.',
    secretLabel: 'Anahtar',
    failed: 'İşlem tamamlanamadı',
    notFound: 'Kullanıcı bulunamadı ya da bu kaydı görme yetkiniz yok.',
    userTitle: 'Kullanıcı kaydı',
    email: 'E-posta',
    role: 'Rol',
    status: 'Durum',
  },
} as const;
